module.exports = __webpack_public_path__ + "static/img/madam_classroom.7b494a56.png";